import { useLanguage } from "@/context/LanguageContext";
import Reveal from "@/components/Reveal";

const Method = () => {
  const { t } = useLanguage();

  return (
    <section id="metoda" data-testid="section-method" className="relative overflow-hidden py-24 md:py-32">
      <div className="pointer-events-none absolute left-1/2 top-0 h-px w-full max-w-7xl -translate-x-1/2 bg-gradient-to-r from-transparent via-black/10 to-transparent" aria-hidden="true" />

      <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-12 lg:gap-20">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-36">
            <Reveal>
              <p className="text-xs font-medium uppercase tracking-[0.28em] text-[#5C5C5C]">{t.method.eyebrow}</p>
              <h2 className="mt-5 font-display text-4xl font-medium leading-[1.1] tracking-tight text-[#1A1A1A] md:text-5xl">
                {t.method.title}
              </h2>
            </Reveal>
            <Reveal delay={0.08}>
              <p className="mt-7 text-base leading-relaxed text-[#5C5C5C] md:text-lg">{t.method.intro}</p>
              <p className="mt-4 text-base leading-relaxed text-[#5C5C5C] md:text-lg">{t.method.intro2}</p>
            </Reveal>
          </div>
        </div>

        <div className="relative lg:col-span-7">
          <span className="absolute left-[1.35rem] top-2 h-[calc(100%-1rem)] w-px bg-gradient-to-b from-[#FF6B6B] via-[#F9D876] via-30% to-[#45B7D1] opacity-60 md:left-[1.85rem]" aria-hidden="true" />
          <ol className="space-y-10">
            {t.method.steps.map((step, i) => (
              <Reveal key={step.t} delay={0.05 * i}>
                <li className="relative flex gap-6 md:gap-8" data-testid={`method-step-${i + 1}`}>
                  <span className="relative z-10 flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-black/[0.08] bg-[#FDFBF7] font-display text-lg font-semibold italic text-[#1A1A1A] md:h-14 md:w-14 md:text-xl">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="pt-1.5 md:pt-3">
                    <h3 className="font-display text-2xl font-semibold tracking-tight text-[#1A1A1A] md:text-[1.65rem]">{step.t}</h3>
                    <p className="mt-2 max-w-lg text-sm leading-relaxed text-[#5C5C5C] md:text-base">{step.d}</p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default Method;
